import { combineReducers } from 'redux';

import admin from './admin';
import auth from './auth';
import errors from './errors';
import races from './races';

export default combineReducers({ admin, auth, errors, races });
